import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import VehicleTypeReducer from "./reducer";
const VehicleType = combineReducers({
  vehicleType: VehicleTypeReducer,
  form: formReducer,
});

export default VehicleType;
